<template>
  <div class="introduction" id="introduction-section">
    <div class="content">
      <div>
        <swiper
          :loop="true"
          :modules="modules"
          :pagination="{
            clickable: true,
          }"
          :slides-per-view="1"
          :space-between="45"
          :speed="750"
          :autoplay="{ delay: 5000, disableOnInteraction: false }">
          <swiper-slide v-for="(item, index) in translations[lang]" :key="index">
            <IntroductionItem :slide="item" :lang="lang" :class="item.slideClass" :thumb-mobile="item.thumbMobile">
              <template #intro1>
                <button v-if="lang === 'ru'" @click="scrollToShowcase" class="custom-button introductionItem__button" v-text="lang === 'en' ? 'Upload a floor plan' : 'Посмотреть наборы'"></button>
                <router-link :to="{ path: '/pricing' }" class="custom-button introductionItem__button btn-service-upload-1" v-else>Upload a floor plan</router-link>
              </template>
              <template #intro5>
                <button v-if="lang === 'ru'" @click="scrollToShowcase" class="custom-button introductionItem__button">Посмотреть наборы</button>
                <router-link v-else :to="{ path: '/news/new-update' }" class="custom-button introductionItem__button"> Learn more </router-link>
              </template>
              <template #intro2>
                <button v-if="lang === 'ru'" @click="openModal" class="custom-button introductionItem__button">Узнать больше</button>
                <router-link :to="{ path: '/news/unique-style' }" class="custom-button introductionItem__button btn-service-learn-1" v-else> Learn more </router-link>
              </template>
              <template #intro3>
                <button v-if="lang === 'ru'" @click="openModal" class="custom-button introductionItem__button">Узнать больше</button>
                <router-link :to="{ path: '/news/trust-factors' }" class="custom-button introductionItem__button btn-service-learn-2" v-else> Learn more </router-link>
              </template>
              <template #intro4>
                <router-link :to="{ path: '/news/window-type' }" class="custom-button introductionItem__button btn-service-learn-3"> Learn more </router-link>
              </template>
            </IntroductionItem>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import IntroductionItem from '@/Components/En/MainPage/IntroductionItem.vue';

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Pagination } from 'swiper/modules';
import { smoothScroll } from '@/helpers';
import 'swiper/swiper-bundle.css';

export default {
  name: 'Introduction',
  components: {
    IntroductionItem,
    Swiper,
    SwiperSlide,
  },
  props: {
    lang: {
      type: String,
      default: 'en',
    },
    open: {
      default: () => null,
      type: Function,
    },
  },
  setup() {
    return {
      modules: [Autoplay, Pagination],
    };
  },
  data() {
    return {
      translations: {
        en: [
          {
            button: 'intro1',
            description: '<span>AI to create</span> 2D, 3D floor plans <br/>and virtual tours',
            target: '#toolchoose-section',
            thumb: 'introduction/plan.webp',
            thumbMobile: 'introduction/plan_mobile.jpg',
            title: 'Floor plan<br/>In 24 hours',
            style: 'full',
            slideClass: 'intro1-slide',
          },
          {
            button: 'intro5',
            description: 'Professional 3D quality, 360 tour<br/>from AI in 24h',
            target: '#toolchoose-section',
            thumb: 'introduction/new_update.png',
            title: '360 tour<br/>is a new level<br/>by AI!',
            style: 'full',
          },
          {
            button: 'intro2',
            description: "Let's create your style on Mixed style",
            gradient: 'true',
            target: '#toolchoose-section',
            thumb: 'introduction/ai.webp',
            title: 'Interiors by AI',
            style: 'full',
          },
          {
            button: 'intro3',
            description: '2D, 3D views, offer samples',
            gradient: 'true',
            target: '#toolchoose-section',
            thumb: 'introduction/estate-managment.png',
            title: 'Special for<br/>real estate<br/>management ',
            style: 'full',
          },
          {
            button: 'intro4',
            description: 'On step 2 of the order, select:<br/>panoramic or standard',
            gradient: 'true',
            target: '#toolchoose-section',
            thumb: 'introduction/grafics.webp',
            title: 'Update: Сhoose<br/>windows',
            style: 'full',
          },
        ],
        ru: [
          {
            button: 'intro1',
            description: '<span>ИИ создаёт</span> 2D, 3D планировки <br/>с виртуальным туром',
            target: '#toolchoose-section',
            thumb: 'introduction/plan.webp',
            thumbMobile: 'introduction/plan_mobile.jpg',
            title: '3D планы<br/>за 24 часа',
            style: 'full',
            slideClass: 'intro1-slide',
          },
          {
            button: 'intro5',
            description: 'Профессиональное качество 3D<br/>виртуальный тур от ИИ за 24 часа',
            target: '#toolchoose-section',
            thumb: 'introduction/new_update_ru.webp',
            title: 'Тур-360 – новый<br/>уровень от ИИ!',
            style: 'full',
          },
          {
            button: 'intro2',
            description: 'Соберите свой стиль<br/>Услуга "Мой стиль"',
            target: '#toolchoose-section',
            thumb: 'introduction/ai.webp',
            title: 'Интерьеры<br/>от ИИ',
            style: 'full',
            slideClass: 'intro1-slide',
          },
          {
            button: 'intro3',
            description: 'Покупатели узнают еще больше <br/>об их будущей квартире',
            target: '#toolchoose-section',
            thumb: 'introduction/grafics.webp',
            title: 'Выбирайте<br/>тип окон',
            style: 'full',
          },
        ],
      },
    };
  },
  methods: {
    scrollToShowcase() {
      smoothScroll('showcase');
    },
    openModal() {
      this.open();
    },
  },
};
</script>
